import React, { useEffect, useState } from 'react'
import AdminHeader from './AdminHeader.js'
import { GoCircle } from "react-icons/go";
import { SlLocationPin } from "react-icons/sl";
import { useQuery } from '@apollo/client';
// import { GET_ALL_USER } from '../graphql/Query/Signin.js';
import { useLocation } from 'react-router-dom';
import { GET_ORDERS_BY_ID } from '../graphql/Query/Order.js';
import moment from 'moment';
import PriceCalculator from '../DocumentShiping/priceCalculator.js';
import { handleLogin } from '../Common/TokenLogin.js';
import useScrollToTop from '../components/useScrollToTop.js';
import { GET_REFUND_STATUS } from '../graphql/Query/paymentRefund.js';
import { API_URL } from '../config.js';
import axios from 'axios';
import { parseEcomResponse } from '../OrderPage/SingleTrack.js';
import { FaCheckCircle } from 'react-icons/fa';


const AdminTrack = () => {
    useScrollToTop();

    const [trackingData, setTrackingData] = useState(null);
    const location = useLocation();
    const getId = location?.state?.id;
    const orderId = location?.state?.orderId;
    // console.log('✌️orderId --->', orderId);
    const { data: GetOrderOrder } = useQuery(GET_ORDERS_BY_ID, {
        variables: {
            "getOrderId": getId
        }
    });

    const { data: GetOrderOrderId } = useQuery(GET_REFUND_STATUS, {
        variables: { orderId: orderId }
    });
    // console.log('✌️GetOrderOrderId --->', GetOrderOrderId);

    useEffect(() => {

        const trackShipment = async () => {
            if (GetOrderOrder?.getOrder?.Shipment_name === "EC") {
                const awb = GetOrderOrder?.getOrder?.awb_number
                try {
                    // console.log('✌️awb --->', awb);
                    const response = await axios.get(`${API_URL}/track-awb`, {
                        params: { awb }
                    });
                    if (response?.status === 200) {
                        const parsed = parseEcomResponse(response?.data);
                        // console.log('✌️parsed --->', parsed);
                        setTrackingData({ data: parsed });
                    }
                } catch (error) {
                    // console.log('✌️error --->', error);
                }
            } else {
                const url = `https://shipment.xpressbees.com/api/shipments2/track/${GetOrderOrder?.getOrder?.awb_number}`;
                const authToken = await handleLogin();
                try {

                    const axiosResponse = await axios.get(url, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${authToken}`,
                        }
                    });

                    const data = axiosResponse?.data;

                    setTrackingData(data);
                } catch (err) {
                    console.error('Error tracking shipment:', err);
                }
            }
        };

        if (GetOrderOrder?.getOrder?.awb_number) {
            trackShipment();
        }
    }, [GetOrderOrder?.getOrder?.awb_number]);


    return (
        <div>
            <AdminHeader />
            <div className='mx-auto md:pt-14 pt-9 pb-9 max-w-auto px-6 md:space-y-10 space-y-9 lg:px-8'>
                <p className='text-2xl font-semibold'>Track Shipment Details</p>
                <div className='flex justify-between'>
                    <div className='space-y-2'>
                        <p className='text-sm font-semibold text-gray-500'>Shipment ID <span>{GetOrderOrder?.
                            getOrder
                            ?.order_id}</span></p>
                        <p className='text-sm font-semibold text-gray-500'>Shipment No <span>{GetOrderOrder?.
                            getOrder
                            ?.order_number}</span></p>
                        <p className='text-sm font-semibold text-gray-500'>AWB NO. <span>{GetOrderOrder?.getOrder?.awb_number}</span></p>
                        <p className='text-sm text-gray-500'>{moment(GetOrderOrder?.getOrder?.createdAt).format('DD/MM/YYYY hh:mm A')}</p>
                    </div>
                    <div>  <span className="block font-bold md:text-end text-start  mt-1 sm:mt-0 text-black">{GetOrderOrder?.getOrder?.payment_type?.toUpperCase()}</span>
                        {GetOrderOrder?.getOrder?.payment_type === 'cod' ? <span className="block font-semibold md:text-end text-start  mt-1 sm:mt-0 text-black">Cash on Delivery Collectible ₹{GetOrderOrder?.getOrder?.ProductPrice}</span> : ''}
                    </div>
                </div>
                <div className='grid gap-x-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-9'>
                    <div className='p-5 border border-slate-300 rounded-lg'>
                        <div className='space-y-4'>
                            <p className='text-md font-semibold'>Address Details </p>
                            <div className='flex space-x-4'>
                                <div className='space-y-1 text-gray-400'>
                                    <GoCircle />
                                    <ul className='ms-1.5'>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3'>I</li>
                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                        <li className='text-xs leading-3 sm:hidden'>I</li>
                                    </ul>
                                    <SlLocationPin />
                                </div>
                                <div className='space-y-4'>
                                    <div>
                                        <p className='text-sm font-semibold mb-1'>{GetOrderOrder?.
                                            getOrder
                                            ?.pickupAddress?.name}  <span className='ms-1 text-gray-400'>(Pickup)</span></p>
                                        <p className='text-sm text-gray-500'>{GetOrderOrder?.
                                            getOrder
                                            ?.pickupAddress?.address1} , {GetOrderOrder?.
                                                getOrder
                                                ?.pickupAddress?.city} , {GetOrderOrder?.
                                                    getOrder
                                                    ?.pickupAddress?.stateId?.name} - {GetOrderOrder?.
                                                        getOrder
                                                        ?.pickupAddress?.zipCode}</p>
                                        <p className='text-sm text-gray-500'>{GetOrderOrder?.
                                            getOrder
                                            ?.pickupAddress?.phone}</p>
                                    </div>
                                    <div>
                                        <p className='text-sm font-semibold mb-1'>{GetOrderOrder?.
                                            getOrder
                                            ?.deliveryAddress?.name} <span className='ms-1 text-gray-400'>(delivery)</span></p>
                                        <p className='text-sm text-gray-500'>{GetOrderOrder?.
                                            getOrder
                                            ?.deliveryAddress?.address1} , {GetOrderOrder?.
                                                getOrder
                                                ?.deliveryAddress?.city} , {GetOrderOrder?.
                                                    getOrder
                                                    ?.deliveryAddress?.stateId?.name} - {GetOrderOrder?.
                                                        getOrder
                                                        ?.deliveryAddress?.zipCode}</p>
                                        <p className='text-sm text-gray-500'>{GetOrderOrder?.
                                            getOrder
                                            ?.deliveryAddress?.phone}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {trackingData && (
                        <div className="max-w-2xl w-full mx-auto p-4 sm:p-6 border border-slate-300 rounded-lg  bg-white">
                            <h2 className="text-md font-semibold pb-4">Tracking Information</h2>
                            <p className="font-medium text-sm">AWB Number: {trackingData?.data?.awb_number}</p>
                            <p className="font-medium text-sm">Status: {trackingData?.data?.status}</p>
                            <p className="border-t mt-2"></p>

                            {/* Responsive Scrollable Container */}
                            <div className="h-64 sm:h-80 overflow-y-auto overflow-x-auto">
                                <div className="relative mt-4 pl-1 min-w-max w-full">
                                    {/* Vertical Line */}
                                    <div className="absolute left-[15px] top-2 bottom-0 w-[2px] bg-green-400 transition-colors group-hover:bg-black"></div>

                                    {trackingData?.data?.history?.map((event, index) => (
                                        <div key={index} className="relative flex items-start gap-4 mb-6 group">
                                            {/* Icon Container for Proper Alignment */}
                                            <div className="relative flex items-center">
                                                <FaCheckCircle className="text-green-500 text-2xl bg-white rounded-full z-10 transition-colors" />
                                            </div>

                                            {/* Event Details */}
                                            <div className="space-y-1 text-xs sm:text-sm">
                                                <p className="font-semibold text-gray-900">{event.event_time}</p>
                                                <p className="text-gray-600">{event.location}</p>
                                                <p className="text-gray-700">{event.message}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )}




                    {/* {trackingData && (
                        <div className='p-5 border border-slate-300 rounded-lg'>
                            <p className='text-md font-semibold pb-4'>Tracking Information</p>
                            <div className='space-y-2'>
                                <p className='font-medium text-sm'>AWB Number: {trackingData?.data?.awb_number}</p>
                                <p className='font-medium text-sm'>Status: {trackingData?.data?.status}</p>
                                <div className='border-t pt-3 space-y-3 '>
                                    <p className='text-sm font-semibold '>History:</p>
                                    {trackingData?.data?.history?.map((event, index) => (
                                        <div key={index} className='text-sm text-gray-500'>
                                            <p>{event?.event_time} - {event?.location}</p>
                                            <p>{event?.message}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )} */}


                    <div className='p-5 border border-slate-300 rounded-lg'>
                        <PriceCalculator orderAmount={GetOrderOrder?.getOrder?.order_amount} />
                    </div>

                    <div className='p-5 border border-slate-300 rounded-lg'>
                        <p className='text-md font-semibold pb-4'>Package Information</p>
                        <div className='space-y-3'>
                            <div className='flex justify-between'>
                                <p className='text-sm text-gray-500'>Product :</p>
                                <p className='text-sm'>{GetOrderOrder?.
                                    getOrder
                                    ?.ProductName}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='text-sm text-gray-500'>Valuation :</p>
                                <p className='text-sm'>Rs.{GetOrderOrder?.
                                    getOrder
                                    ?.ProductPrice}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='text-sm text-gray-500'>Shipment :</p>
                                <p className='text-sm'>{GetOrderOrder?.
                                    getOrder
                                    ?.courier_name}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='text-sm text-gray-500'>Weight :</p>
                                <p className='text-sm'>{GetOrderOrder?.
                                    getOrder
                                    ?.package_weight_Length}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='text-sm text-gray-500'>Status :</p>
                                <p className='text-sm'>{GetOrderOrder?.
                                    getOrder
                                    ?.trackStatus}</p>
                            </div>
                            <div className='flex justify-between'>
                                <p className='text-sm text-gray-500'>Amount :</p>
                                <p className='text-sm'>{GetOrderOrder?.
                                    getOrder
                                    ?.order_amount}</p>
                            </div>
                        </div>
                    </div>

                    <div className='p-5 border border-slate-300 rounded-lg'>
                        {GetOrderOrder?.
                            getOrder
                            ?.paymentDetails.map((items) => {
                                return (
                                    <>
                                        <p className='text-lg font-semibold pb-4'>Payment Details</p>
                                        <div className='space-y-3'>

                                            <p className='text-md font-semibold'>Payment Method</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Type :</p>
                                                <p className='text-sm'>{items?.payment_group}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Receive :</p>
                                                <p className='text-sm'>{items?.payment_method?.upi?.channel}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>UPI ID :</p>
                                                <p className='text-sm'>{items?.payment_method?.upi?.upi_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Status :</p>
                                                <p className='text-sm'>{items?.payment_status}</p>
                                            </div>


                                            <p className='text-md font-semibold'>Payment Gateway Details</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Shipment ID :</p>
                                                <p className='text-sm'>{items?.payment_gateway_details?.gateway_order_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment ID :</p>
                                                <p className='text-sm'>{items?.payment_gateway_details?.gateway_payment_id}</p>
                                            </div>

                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Amount :</p>
                                                <p className='text-sm'>{items?.payment_amount}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment Date :</p>
                                                <p className='text-sm'>{moment(items?.payment_completion_time).format('DD/MM/YYYY hh:mm A')}</p>


                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                    </div>
                    {GetOrderOrderId?.getRefundStatus &&
                        <div className='p-5 border border-slate-300 rounded-lg'>
                            {GetOrderOrderId?.getRefundStatus?.map((items) => {
                                return (
                                    <>
                                        <p className='text-lg font-semibold pb-4'>Payment Refund Details</p>
                                        <div className='space-y-3'>

                                            <p className='text-md font-semibold'>Payment Refund Method</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment refund_charge :</p>
                                                <p className='text-sm'>{items?.refund_charge}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>refund_id :</p>
                                                <p className='text-sm'>{items?.refund_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>refund_status :</p>
                                                <p className='text-sm'>{items?.refund_status}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>status_description :</p>
                                                <p className='text-sm'>{items?.status_description}</p>
                                            </div>


                                            <p className='text-md font-semibold'>Payment Gateway Details</p>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment cf_payment_id :</p>
                                                <p className='text-sm'>{items?.cf_payment_id}</p>
                                            </div>
                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment cf_refund_id :</p>
                                                <p className='text-sm'>{items?.cf_refund_id}</p>
                                            </div>

                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment refund_amount :</p>
                                                <p className='text-sm'>{items?.refund_amount}</p>
                                            </div> <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment order_id :</p>
                                                <p className='text-sm'>{items?.order_id}</p>
                                            </div>

                                            <div className='flex justify-between'>
                                                <p className='text-sm text-gray-500'>Payment created_at :</p>
                                                <p className='text-sm'>{items?.created_at}</p>
                                            </div>
                                        </div>
                                    </>
                                )
                            })}
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default AdminTrack
